module.exports = __webpack_public_path__ + "static/media/Target.6d42ba56.svg";